module.exports = __webpack_public_path__ + "img/phone.854246fa.svg";